import { Column, Entity, ManyToOne, PrimaryColumn } from "typeorm";
import { SubjectSchema } from "./subject.schema";

@Entity()
export class SubjectAttributesSchema {
  @PrimaryColumn()
  id: string;

  @Column({ nullable: true })
  subjectId: string | null;

  @Column({ nullable: true })
  version: number | null;

  @Column({ nullable: true })
  owner: string | null;

  @Column({ nullable: true })
  country: string | null;

  @Column({ nullable: true })
  state: string | null;

  @Column({ nullable: true })
  district: string | null;

  @Column({ nullable: true })
  site: string | null;

  @Column({ nullable: true })
  project: string | null;

  @Column({ nullable: true })
  isNewestVersion: boolean | null;

  // relations
  @ManyToOne("SubjectSchema", "attributes")
  subject: SubjectSchema;

  constructor(
    subjectId: string | null,
    version: number | null,
    owner: string | null,
    country: string | null,
    state: string | null,
    district: string | null,
    site: string | null,
    project: string | null,
    isNewestVersion: boolean | null
  ) {
    this.id = `${subjectId}_${version}`;
    this.subjectId = subjectId;
    this.version = version;
    this.owner = owner;
    this.country = country;
    this.state = state;
    this.district = district;
    this.site = site;
    this.project = project;
    this.isNewestVersion = isNewestVersion;
  }
}
